import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {ListClientesEntidadComponent} from './list-clientes-entidad/list-clientes-entidad.component';


const routes: Routes = [
  {
    path: '',
    component: ListClientesEntidadComponent,
    pathMatch: 'full'
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClientesEntidadRoutingModule { }
